import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const RequirementsField = ({name, label, register, setValue, errors}) => {

    const [requirement, setRequirement] = useState("");
    const [requirementsList, setRequirementsList] = useState([]);
    const {course, editCourse} = useSelector((state) => state.course);

    useEffect(()=>{
        if(editCourse){
            setRequirementsList(course?.instructions);
        }
        register(name, {
            required: true,
            validate: (value) => value.length > 0,
        });
    }, []);

    useEffect(()=>{
        setValue(name, requirementsList);
    }, [requirementsList]);

    const handleAddRequirement = ()=>{
        if(requirement){
            setRequirementsList([...requirementsList, requirement]);
            setRequirement("");
        }
    }

    const handleRemoveRequirement = (i)=>{
        const updateList = [...requirementsList];
        updateList.splice(i, 1);
        setRequirementsList(updateList);
    }

    return (
        <div className='flex flex-col space-y-2'>
            <label className="text-sm text-richblack-5" htmlFor={name}> {label} <sup className="text-pink-200">*</sup></label>
            <div className="flex flex-col items-start space-y-2">
                <input type="text" id={name} value={requirement} onChange={(e) => setRequirement(e.target.value)} className="form-style w-full"/>
                <button className="font-semibold text-yellow-50" type='button' onClick={handleAddRequirement}>Add</button>
            </div>
            {
                requirementsList.length > 0 && (
                    <ul className="mt-2 list-inside list-disc">
                        {
                            requirementsList.map((requirement, i)=>(
                                <li className="flex items-center text-richblack-5" key={i}>
                                    <span>{requirement}</span>
                                    <button type="button" className='ml-2 text-xs text-pure-greys-300 ' 
                                        onClick={()=> handleRemoveRequirement(i)}
                                    >
                                        Clear
                                    </button>
                                </li>
                            ))
                        }
                    </ul>
                )
            }
            {
                errors[name] && (
                    <span className='ml-2 text-xs tracking-wide text-pink-200'>
                        {name} is required
                    </span>
                )
            }
        </div>
    )
}

export default RequirementsField
